import history from "../../../utilities/history";

const redirectToIBPlanning = () => {
  history.push("/");
};

const getInitialStepData = () => {
  // This method is to return initial data for each step.
  return { 1: [], 2: [] };
};

export { redirectToIBPlanning, getInitialStepData };
